// NodeToolbar.jsx

import React from 'react';

// CSS
import './NodeToolbar.css';

// Components
import Tabs from 'components/tabs/Tabs';

/**
 * NodeToolbar
 *
 * @returns {ReactNode} The rendered component.
 */
const NodeToolbar = React.memo(({
  tabs,
  selectedTabKey,
  isMobile,
  layout = 'row',
  addRelatedButton = null,
}) => {

  const isWrapLayout = layout === 'wrap';

  // ----- RENDER ----- //

  return (
    <div
      className={`node-toolbar${isWrapLayout ? ' node-toolbar--wrap' : ''}`}
      style={{
        marginTop: isMobile ? 12 : 0,
      }}
    >
      <div className="node-tabs-wrapper">
        <Tabs
          tabs={tabs}
          selectedKey={selectedTabKey}
          layout={layout}
          endSlot={isWrapLayout ? addRelatedButton : null}
        />
      </div>

      {!isWrapLayout ? addRelatedButton : null}
    </div>
  );
});

// Dev Tools
NodeToolbar.displayName = 'NodeToolbar';

export default NodeToolbar;
